import { render, staticRenderFns } from "./AboutCoopnetLogoComponent.vue?vue&type=template&id=c04d5998&"
import script from "./AboutCoopnetLogoComponent.vue?vue&type=script&lang=js&"
export * from "./AboutCoopnetLogoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports